import React from "react";
import { Route, Routes } from "react-router";
import List from "./List";
import Add from "./Add";
import Edit from "./Edit";

const MyServices: React.FC = () => {
    return (
        <Routes>
            <Route index element={<List />} />
            <Route path="ajouter" element={<Add />} />
            <Route path=":id/modifier" element={<Edit />} />
        </Routes>
    );
};

export default MyServices;
